import { canBeCastToPaymentCurrency } from '@elfsight/lib-stripe-integration';
import type { CalculationType } from '../../types';

export function isCalculationEligibleForPayment({
  visible,
  format
}: Partial<Pick<CalculationType, 'visible' | 'format'>>) {
  return (
    visible &&
    format?._mode === 'currency' &&
    canBeCastToPaymentCurrency(format._currency)
  );
}
